<app-dialog
  #dialog
  [key]="'company-partner-modal'"
  [action]="'company-partner-modal'"
  [headerTheme]="'simple'"
  [title]="isEditMode ? 'Editar Sócio' : 'Adicionar Sócio'"
  [appendTo]="'body'"
  [maxWidth]="'480px'">
  <div class="p-4">
    <div class="row g-3">
      <div class="col-12">
        <app-input
          label="Nome *"
          type="text"
          placeholder="Nome completo do sócio"
          [(ngModel)]="name">
        </app-input>
      </div>

      <div class="col-12">
        <app-select
          label="Qualificação *"
          placeholder="Selecione a qualificação"
          [allowEmptyPlaceholderSelect]="true"
          [options]="qualificationOptions"
          [selectedValue]="qualification"
          (sendSelectedOption)="qualification = $event?.value ?? null">
        </app-select>
      </div>

      <div class="col-12">
        <app-input
          label="País de Origem"
          type="text"
          placeholder="Ex: Brasil"
          [(ngModel)]="countryOfOrigin">
        </app-input>
      </div>

      <div class="col-12">
        <app-input
          label="Nome do Representante Legal"
          type="text"
          [(ngModel)]="legalRepresentativeName">
        </app-input>
      </div>

      <div class="col-12">
        <app-input
          label="Qualificação do Representante"
          type="text"
          [(ngModel)]="legalRepresentativeQualification">
        </app-input>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Confirmar'"
        [disabled]="!isFormValid()"
        [isLoading]="isLoading"
        (sendButtonClick)="submitAction()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
